class KalonyaProductTop {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('form');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.variantInput = section.querySelector('[data-variant-input]');
    this.priceCurrent = section.querySelector('[data-price-current]');
    this.priceCompare = section.querySelector('[data-price-compare]');
    this.priceCompareWrap = section.querySelector('.kp-price-compare-wrap');
    this.priceDiscount = section.querySelector('[data-price-discount]');
    this.stockAlert = section.querySelector('[data-stock-alert]');
    this.stockCount = section.querySelector('[data-stock-count]');
    this.addToCart = section.querySelector('[data-add-to-cart]');
    this.addToCartMessage = section.querySelector('[data-add-to-cart-message]');
    this.notifyButton = section.querySelector('[data-notify-button]');
    this.notifyPanel = section.querySelector('[data-notify-panel]');
    this.notifyForm = section.querySelector('[data-notify-form]');
    this.notifyMessage = section.querySelector('[data-notify-message]');
    this.mainImage = section.querySelector('[data-main-image]');
    this.variantOptions = Array.from(section.querySelectorAll('[data-variant-option]'));
    this.singleVariantState = section.querySelector('[data-single-variant-state]');
    this.thumbnails = Array.from(section.querySelectorAll('[data-thumbnail]'));
    this.bundleInfoButtons = Array.from(section.querySelectorAll('[data-bundle-info-button]'));

    this.bindVariantOptions();
    this.bindThumbnails();
    this.bindBundleInfoButtons();
    this.bindForm();
    this.bindNotify();
    this.syncInitialState();
  }

  bindVariantOptions() {
    this.variantOptions.forEach((option) => {
      option.addEventListener('click', () => this.selectVariant(option));
    });
  }

  bindThumbnails() {
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        this.setMainImage(thumbnail.dataset.imageUrl, thumbnail.dataset.imageSrcset);
        this.setActiveThumbnail(thumbnail.dataset.imageUrl);
      });
    });
  }

  bindBundleInfoButtons() {
    this.bundleInfoButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('kalonya:bundle-product-info', {
          detail: {
            productId: button.dataset.bundleProductId,
          },
        }));
      });
    });
  }

  bindForm() {
    if (!this.form || !this.addToCart) return;

    this.form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (this.addToCart.disabled) return;

      const initialState = this.getCurrentVariantState();
      this.setMessage('');
      const originalLabel = this.addToCart.textContent;
      this.addToCart.disabled = true;
      this.addToCart.setAttribute('aria-busy', 'true');

      try {
        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        } else {
          formData.append('sections', 'cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }

        const response = await fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
          },
          body: formData,
        });
        const payload = await response.json();

        if (!response.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'Errore durante l\'aggiunta al carrello.');
        }

        if (this.cart && payload.sections) {
          this.cart.renderContents(payload);
        } else {
          this.updateCartIcon(payload.sections);
        }

        this.setMessage(
          initialState.isPreorder
            ? this.addToCart.dataset.preorderSuccessLabel || 'Pre-ordine aggiunto al carrello'
            : this.addToCart.dataset.successLabel || 'Aggiunto al carrello'
        );

        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
          window.Shopify.onItemAdded(payload);
        }
      } catch (error) {
        this.setMessage(error.message || 'Errore durante l\'aggiunta al carrello.', true);
      } finally {
        const state = this.getCurrentVariantState();
        this.addToCart.disabled = state.isDisabled;
        this.addToCart.removeAttribute('aria-busy');
        this.addToCart.textContent = state.primaryLabel || originalLabel;
      }
    });
  }

  bindNotify() {
    if (!this.notifyButton || !this.notifyPanel) return;

    this.notifyButton.addEventListener('click', () => {
      this.notifyPanel.hidden = false;
      this.notifyPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      const firstInput = this.notifyPanel.querySelector('input, button, select, textarea, a[href]');
      if (firstInput) {
        firstInput.focus({ preventScroll: true });
      }
    });

    if (!this.notifyForm) return;

    this.notifyForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const endpoint = this.notifyPanel.dataset.notifyEndpoint;
      const emailInput = this.notifyForm.querySelector('input[name="email"]');
      const consentInput = this.notifyForm.querySelector('input[name="accepts_marketing"]');
      const submitButton = this.notifyForm.querySelector('button[type="submit"]');
      const state = this.getCurrentVariantState();

      if (!endpoint) {
        this.setNotifyMessage('Le notifiche non sono ancora configurate.', true);
        return;
      }

      if (!emailInput || !emailInput.value) {
        this.setNotifyMessage('Inserisci un indirizzo email valido.', true);
        return;
      }

      this.setNotifyMessage('');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: emailInput.value,
            acceptsMarketing: Boolean(consentInput?.checked),
            productId: this.notifyPanel.dataset.productId,
            variantId: state.variantId,
            productTitle: this.notifyPanel.dataset.productTitle,
            variantTitle: state.variantTitle,
            productUrl: this.notifyPanel.dataset.productUrl,
          }),
        });
        const payload = await response.json().catch(() => ({}));

        if (!response.ok || payload.error) {
          throw new Error(payload.error || 'Non siamo riusciti a salvare la richiesta.');
        }

        this.setNotifyMessage(payload.message || 'Ti avviseremo quando il prodotto torna disponibile.');
        this.notifyForm.reset();
      } catch (error) {
        this.setNotifyMessage(error.message || 'Non siamo riusciti a salvare la richiesta.', true);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
      }
    });
  }

  syncInitialState() {
    const selectedOption = this.variantOptions.find((option) => option.classList.contains('is-selected'));
    if (selectedOption) {
      this.updateStockAlert(selectedOption.dataset);
      this.updateActions(selectedOption.dataset);
      return;
    }

    if (this.singleVariantState) {
      this.updateStockAlert(this.singleVariantState.dataset);
      this.updateActions(this.singleVariantState.dataset);
    }
  }

  selectVariant(option) {
    this.variantOptions.forEach((item) => item.classList.remove('is-selected'));
    option.classList.add('is-selected');

    if (this.variantInput) {
      this.variantInput.value = option.dataset.variantId;
    }

    if (this.priceCurrent) {
      this.priceCurrent.textContent = option.dataset.price;
    }

    const hasComparePrice = option.dataset.hasCompare === 'true';
    if (this.priceCompareWrap) {
      this.priceCompareWrap.hidden = !hasComparePrice;
    }
    if (this.priceCompare) {
      this.priceCompare.textContent = hasComparePrice ? option.dataset.comparePrice : '';
    }
    if (this.priceDiscount) {
      if (hasComparePrice && option.dataset.compareAtPrice && option.dataset.priceRaw) {
        const compare = parseInt(option.dataset.compareAtPrice, 10);
        const current = parseInt(option.dataset.priceRaw, 10);
        const pct = Math.round((compare - current) * 100 / compare);
        this.priceDiscount.textContent = `-${pct}%`;
      } else {
        this.priceDiscount.textContent = '';
      }
    }

    this.updateStockAlert(option.dataset);
    this.updateActions(option.dataset);

    if (option.dataset.featuredImage) {
      this.setMainImage(option.dataset.featuredImage, option.dataset.featuredSrcset);
      this.setActiveThumbnail(option.dataset.featuredImage);
    }
  }

  getCurrentVariantState() {
    const selectedOption = this.variantOptions.find((option) => option.classList.contains('is-selected'));
    const variantData = selectedOption ? selectedOption.dataset : this.singleVariantState?.dataset;
    return this.getActionState(variantData);
  }

  getActionState(variantData) {
    const isAvailable = variantData?.available === 'true';
    const isInventoryManaged = variantData?.inventoryManaged === 'true';
    const inventoryQuantity = Number.parseInt(variantData?.inventoryQuantity || '0', 10);
    const isOutOfStock = !isAvailable || (isInventoryManaged && inventoryQuantity <= 0);
    const preorderEnabled = variantData?.preorderEnabled === 'true';
    const notifyEnabled = variantData?.notifyEnabled === 'true';
    const isPreorder = isOutOfStock && preorderEnabled;

    let primaryLabel = this.addToCart?.dataset.availableLabel || 'Aggiungi al carrello';
    if (isPreorder) {
      primaryLabel = this.addToCart?.dataset.preorderLabel || 'Pre-ordina';
    } else if (isOutOfStock) {
      primaryLabel = this.addToCart?.dataset.soldOutLabel || 'Sold Out';
    }

    return {
      isAvailable,
      isOutOfStock,
      isPreorder,
      showNotify: isOutOfStock && notifyEnabled,
      primaryLabel,
      isDisabled: isOutOfStock && !isPreorder,
      variantId: variantData?.variantId || this.variantInput?.value || '',
      variantTitle: variantData?.variantTitle || '',
    };
  }

  updateActions(variantData) {
    const state = this.getActionState(variantData);

    if (this.addToCart) {
      this.addToCart.disabled = state.isDisabled;
      this.addToCart.textContent = state.primaryLabel;
      this.addToCart.classList.toggle('is-preorder', state.isPreorder);
    }

    if (this.notifyButton) {
      this.notifyButton.hidden = !state.showNotify;
      this.notifyButton.textContent = this.notifyButton.dataset.notifyLabel || 'Avvisami';
    }

    if (this.notifyPanel && !state.showNotify) {
      this.notifyPanel.hidden = true;
    }
  }

  updateStockAlert(variantData) {
    if (!this.stockAlert || !this.stockCount || !variantData) return;

    const isAvailable = variantData.available === 'true';
    const isInventoryManaged = variantData.inventoryManaged === 'true';
    const inventoryQuantity = Number.parseInt(variantData.inventoryQuantity || '0', 10);
    const shouldShow = isAvailable && isInventoryManaged && inventoryQuantity > 0 && inventoryQuantity <= 5;

    this.stockAlert.hidden = !shouldShow;

    if (shouldShow) {
      this.stockCount.textContent = `${inventoryQuantity}`;
    }
  }

  setMainImage(url, srcset) {
    if (!this.mainImage || !url) return;
    this.mainImage.src = url;
    if (srcset) {
      this.mainImage.srcset = srcset;
    }
  }

  setActiveThumbnail(url) {
    if (!url || this.thumbnails.length === 0) return;
    this.thumbnails.forEach((thumb) => {
      const isMatch = thumb.dataset.imageUrl === url;
      thumb.classList.toggle('is-active', isMatch);
      thumb.setAttribute('aria-current', isMatch ? 'true' : 'false');
    });
  }

  setMessage(message, isError = false) {
    if (!this.addToCartMessage) return;
    this.addToCartMessage.hidden = !message;
    this.addToCartMessage.textContent = message;
    this.addToCartMessage.classList.toggle('is-error', isError);
    this.addToCartMessage.classList.toggle('is-success', Boolean(message) && !isError);
  }

  setNotifyMessage(message, isError = false) {
    if (!this.notifyMessage) return;
    this.notifyMessage.hidden = !message;
    this.notifyMessage.textContent = message;
    this.notifyMessage.classList.toggle('is-error', isError);
    this.notifyMessage.classList.toggle('is-success', Boolean(message) && !isError);
  }

  updateCartIcon(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (!cartIconBubble) return;

    const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    const nextContent = parsed.querySelector('.shopify-section');
    if (nextContent) {
      cartIconBubble.innerHTML = nextContent.innerHTML;
    }
  }
}

function initKalonyaProductTop() {
  document.querySelectorAll('[data-kalonya-product-top]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    new KalonyaProductTop(section);
  });
}

document.addEventListener('DOMContentLoaded', initKalonyaProductTop);
document.addEventListener('shopify:section:load', initKalonyaProductTop);

// ── Reso Garantito popover ──
function initKalonyaPopovers() {
  document.querySelectorAll('.kp-trust-popover-trigger').forEach((trigger) => {
    if (trigger.dataset.popoverInit === 'true') return;
    trigger.dataset.popoverInit = 'true';

    const popoverId = trigger.getAttribute('aria-controls');
    const popover = document.getElementById(popoverId);
    if (!popover) return;

    const closeBtn = popover.querySelector('.kp-popover-close');
    let autoCloseTimer = null;

    function openPopover() {
      popover.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      clearTimeout(autoCloseTimer);
      autoCloseTimer = setTimeout(closePopover, 10000);
    }

    function closePopover() {
      popover.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      clearTimeout(autoCloseTimer);
    }

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      trigger.getAttribute('aria-expanded') === 'true' ? closePopover() : openPopover();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closePopover();
      });
    }

    document.addEventListener('click', (e) => {
      if (!trigger.closest('.kp-trust-item--popover-wrap').contains(e.target)) {
        closePopover();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closePopover();
    });
  });
}

document.addEventListener('DOMContentLoaded', initKalonyaPopovers);
document.addEventListener('shopify:section:load', initKalonyaPopovers);
